import { animated } from '@react-spring/web';
import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { Flex } from '../Core';

export const SectionWrapper = styled(Flex)`
  gap: ${({ theme }) => theme.spacing4}px;
`;

export const AnimatedFlex = styled(animated(Flex))`
  gap: ${({ theme }) => theme.spacing4}px;
`;

export const DistributionWrapper = styled(Flex)<{
  barHeight?: CSSProperties['height'];
  barBorderRadius?: CSSProperties['borderRadius'];
}>`
  --barHeight: ${({ barHeight, theme }) => barHeight ?? `${theme.spacing4}px`};
  --barBorderRadius: ${({ barBorderRadius }) => barBorderRadius ?? 0};
  width: 100%;
  border-radius: var(--barBorderRadius);
  overflow: hidden;
`;
